import React from "react";
import styles from "./JikeiToggleInput.module.scss";

type Props = {
  handleSortJikei: (isJikei: string) => void;
  sortJikei: string;
};
const JikeiToggleInput: React.FC<Props> = ({ handleSortJikei, sortJikei }) => {
  const handleChange = () => {
    if (sortJikei !== "true") {
      handleSortJikei("true");
    } else {
      handleSortJikei("false");
    }
  };
  return (
    <div className={styles["sort-jikei"]}>
      <span className={styles["sort-jikei__title"]}>学生だけを表示する</span>
      <input
        type="checkbox"
        id={"jikei-input"}
        name={"jikei-only"}
        onChange={handleChange}
        checked={sortJikei === "true" ? true : false}
      />
      <label
        className={styles["c-toggle__btn"]}
        htmlFor={"jikei-input"}
      ></label>
    </div>
  );
};

export default JikeiToggleInput;
